import React from "react"
import Card from "@mui/material/Card"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { Button, TableContainer } from "@mui/material"

export default function ViewFacility({
  fac_geo_json,
  current_view_facility_id,
  dispatch_ui,
}) {
  if (!current_view_facility_id) {
    return null
  }

  const current_view_facility = fac_geo_json.features.find(
    (feature) => feature.id === current_view_facility_id,
  )

  return (
    <Card
      style={{
        position: "absolute",
        top: "70px",
        right: "50px",
        zIndex: 500,
        overflow: "auto",
      }}
    >
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Facility Property</b>
              </TableCell>
              <TableCell align="right">
                <b>Value</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(current_view_facility.properties).map(
              ([property, value], index) => {
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {property}
                    </TableCell>
                    <TableCell align="right">{`${value}`}</TableCell>
                  </TableRow>
                )
              },
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        fullWidth
        size="small"
        onClick={() => {
          dispatch_ui({ type: "SET_VIEW_FACILITY", payload: { id: null } })
        }}
      >
        Close Card
      </Button>
    </Card>
  )
}
